module.exports = {"homeSubtitleMargin":"0px 7vh 0px 0px"};


//////////////////
// WEBPACK FOOTER
// ./~/sass-variable-loader/dist!./src/common/css/themes/ND/_override.scss
// module id = 1405
// module chunks = 0